import Effects_common_class from '../abstract/css.js';
import Base_layers_class from './../../../core/base-layers.js';
import ImageFilters from './../../../libs/imagefilters.js';
import alertify from './../../../../../node_modules/alertifyjs/build/alertify.min.js';
import config from "../../../config";
import Dialog_class from './../../../libs/popup.js';
import app from '../../../app.js';

class Effects_normalmap_class {

	constructor() {
		this.POP = new Dialog_class();
		this.Base_layers = new Base_layers_class();
		this.ImageFilters = ImageFilters;
	}

	// -----------------------------
	// UI ENTRY
	// -----------------------------
	normalmap() {
		if (config.layer.type !== 'image') {
			alertify.error('This layer must be an image.');
			return;
            
            
		}
         
		
        
		this.POP.show({
            title: 'Normal Map',
            preview: true,
            params: [
                { name: "strength", title: "Strength:", value: 2.0, range: [0, 10], step: 0.01 },
                { name: "invert", title: "Invert Y:", value: false, type: "checkbox" }
            ],
            on_change: (params, canvas_preview, w, h) => 
            {  
                
               
                // Clear preview canvas  
                canvas_preview.clearRect(0, 0, w, h);  

                // Get current layer data  
                const layerCanvas = this.Base_layers.convert_layer_to_canvas();  

                // Create temporary canvas for processing  
                const tempCanvas = document.createElement('canvas');  
                tempCanvas.width = layerCanvas.width;  
                tempCanvas.height = layerCanvas.height;  
                const tempCtx = tempCanvas.getContext('2d');  

                // Apply blueprint-style base (same as in apply())  
                tempCtx.fillStyle = '#0e58a3';  
                tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);  

                const imgData = layerCanvas.getContext('2d').getImageData(0, 0, layerCanvas.width, layerCanvas.height);  
                const edged = this.ImageFilters.Edge(imgData);  
                const bright = this.ImageFilters.BrightnessContrastPhotoshop(edged, 80, 0);  

                tempCtx.globalCompositeOperation = 'screen';  
                tempCtx.putImageData(bright, 0, 0);  
                tempCtx.globalCompositeOperation = 'source-over';  
                
                // Generate normal map  
                const normalCanvas = this.generate_normal_map(tempCanvas, tempCanvas.width, tempCanvas.height, params);  

                // Draw to preview (scaled to fit)  
                canvas_preview.drawImage(normalCanvas, 0, 0, w, h);  
            },  
            on_finish: (data) => {
                this.apply(data);
            }
        });
	}

	convert_value(v) { return v; }

	// -----------------------------
	// APPLY (destructive)
	// -----------------------------
	apply(data) 
    {
        const params = data || {}; // fallback to empty object
        const layer = config.layer;
        
        const layerCanvas = this.Base_layers.convert_layer_to_canvas();
        const layerCtx = layerCanvas.getContext('2d');
        const imgData = layerCtx.getImageData(0, 0, layerCanvas.width, layerCanvas.height);

        const width = layerCanvas.width;
        const height = layerCanvas.height;

        
        
        // --- Step 1: blueprint-style base ---
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        ctx.fillStyle = '#0e58a3';
        ctx.fillRect(0, 0, width, height);

        const edged = this.ImageFilters.Edge(imgData);
        const bright = this.ImageFilters.BrightnessContrastPhotoshop(edged, 80, 0);

        ctx.globalCompositeOperation = 'screen';
        ctx.putImageData(bright, 0, 0);
        ctx.globalCompositeOperation = 'source-over';

        //this.draw_grid(ctx, 20);

        // --- Step 2: generate normal map ---
        const normalCanvas = this.generate_normal_map(canvas, width, height, params);

        return app.State.do_action(
            new app.Actions.Update_layer_image_action(normalCanvas)
        );
    }

	// -----------------------------
	// NORMAL MAP GENERATION
	// -----------------------------
	generate_normal_map(canvas, width, height, params) {
		const ctx = canvas.getContext('2d');
		const src = ctx.getImageData(0, 0, width, height).data;

		const outCanvas = document.createElement('canvas');
		outCanvas.width = width;
		outCanvas.height = height;
		const outCtx = outCanvas.getContext('2d');
		const outImage = outCtx.createImageData(width, height);
		const dst = outImage.data;

		const strength = params.strength ?? 2.0;
		const invert = params.invert ?? false;
		const zScale = 1.0 / Math.max(0.0001, strength);

		const getH = (x, y) => {
			x = Math.max(0, Math.min(width - 1, x));
			y = Math.max(0, Math.min(height - 1, y));
			const i = (y * width + x) * 4;
			return (src[i]*0.299 + src[i+1]*0.587 + src[i+2]*0.114)/255;
		};

		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++) {
				const tl = getH(x-1,y-1), tc = getH(x,y-1), tr = getH(x+1,y-1);
				const ml = getH(x-1,y), mr = getH(x+1,y);
				const bl = getH(x-1,y+1), bc = getH(x,y+1), br = getH(x+1,y+1);

				let dx = (tr + 2*mr + br) - (tl + 2*ml + bl);
				let dy = (bl + 2*bc + br) - (tl + 2*tc + tr);
				if (invert) dy = -dy;

				let nx = -dx*strength;
				let ny = -dy*strength;
				let nz = zScale;

				const len = Math.hypot(nx, ny, nz) || 1;
				nx/=len; ny/=len; nz/=len;

				const i = (y*width + x)*4;
				dst[i] = (nx*0.5 + 0.5)*255;
				dst[i+1] = (ny*0.5 + 0.5)*255;
				dst[i+2] = (nz*0.5 + 0.5)*255;
				dst[i+3] = 255;
			}
		}

		outCtx.putImageData(outImage, 0, 0);
		return outCanvas;
	}
	demo(canvas_id, canvas_thumb) 
	{  
	  const canvas = document.getElementById(canvas_id);  
	  const ctx = canvas.getContext('2d');  

	  // Use the same defaults as the dialog  
	  const params = { strength: 0.2, invert: false };  

	  // Create a temporary canvas at thumbnail size  
	  const tempCanvas = document.createElement('canvas');  
	  tempCanvas.width = canvas_thumb.width;  
	  tempCanvas.height = canvas_thumb.height;  
	  const tempCtx = tempCanvas.getContext('2d');  

	  // Blueprint-style base (same as on_change/apply)  
	  tempCtx.fillStyle = '#0e58a3';  
	  tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);  

	  const imgData = canvas_thumb.getContext('2d').getImageData(0, 0, canvas_thumb.width, canvas_thumb.height);  
	  const edged = this.ImageFilters.Edge(imgData);  
	  const bright = this.ImageFilters.BrightnessContrastPhotoshop(edged, 80, 0);  

	  tempCtx.globalCompositeOperation = 'screen';  
	  tempCtx.putImageData(bright, 0, 0);  
	  tempCtx.globalCompositeOperation = 'source-over';  

	  // Generate normal map and draw to thumbnail  
	  const normalCanvas = this.generate_normal_map(tempCanvas, tempCanvas.width, tempCanvas.height, params);  
	  ctx.clearRect(0, 0, canvas.width, canvas.height);  
	  ctx.drawImage(normalCanvas, 0, 0);  
	}

}

export default Effects_normalmap_class;

